/**
 * This module provides extensions for ua-parser-js.
 * One of the use cases is to add support for custom
 * Tink User Agents that are injected by mobile-sdk
 */
import { UAParser } from 'ua-parser-js';

const TINK_CUSTOM_BROWSERS: Array<string> = ['Tink-Mobile-SDK'];
/**
 * Generates a ua-parser-js compatible extension for extracting browser name
 * and version from user-agent. Matches custom user-agents of pattern
 * "<browser name>/<browser version>"
 */
const generateCustomBrowserExtension = (browserNames: Array<string>) => {
  const browserNameMatcher = browserNames.join('|');
  const versionGroupMatcher = '[\\w\\.]+';
  const uaRegex = new RegExp(
    [browserNameMatcher, versionGroupMatcher]
      .map((e) => `(${e})`) // make each element into a capture group
      .join('/'),
    'i'
  );

  return [[uaRegex], [UAParser.BROWSER.NAME, UAParser.BROWSER.VERSION]];
};
export const extensions = { browser: generateCustomBrowserExtension(TINK_CUSTOM_BROWSERS) };
